export const API_ENDPOINT_FETCH_DB_TABLES = `${process.env.REACT_APP_API_URL}/finalytics/tables/list`;
export const API_ENDPOINT_FETCH_DB_TABLE_PREVIEW = `${process.env.REACT_APP_API_URL}/finalytics/tables/data/preview`;
export const API_ENDPOINT_SAVE_TABLE_CONFIG_VIEW = `${process.env.REACT_APP_API_URL}/agtable/serverview/save`;
